import { GTMService } from 'app/frontend/lib/shared/util/gtm/gtm.service';
import { UserService } from 'app/frontend/lib/shared/util/user';
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import {AuthService} from "../../auth/auth.service";
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '@teammood/shared/util/logger';
import { OnboardingService } from '../onboarding.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TmValidators } from '@teammood/shared/util/form';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'about-you',
    templateUrl: './aboutyou.component.html',
    providers: [OnboardingService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutYouComponent implements OnInit {
    
    token: string;
    step: { id: string; index: number; } = { id: 'aboutyou', index: 1 };

    form: FormGroup = new FormGroup({
        firstName: new FormControl('', [TmValidators.required, Validators.minLength(2)]),
        lastName: new FormControl('', [TmValidators.required, Validators.minLength(2)]),
        passwordSubForm: new FormGroup({
            password1: new FormControl('', [TmValidators.required, TmValidators.passwordValidFormat]),
            password2: new FormControl('', [TmValidators.required, TmValidators.passwordValidFormat])
        }, [TmValidators.passwordsMatch]),
        terms: new FormControl(false, [Validators.requiredTrue]),
    });

    get firstName() {
        return this.form.get('firstName');
      }
    get lastName() {
        return this.form.get('lastName');
    }
    get password1() {
        return this.passwordSubForm.get('password1');
    }
    get password2() {
        return this.passwordSubForm.get('password2');
    }
    get passwordSubForm() {
        return this.form.get('passwordSubForm');
    }

    constructor(
        private log: LoggerService,
        private authService: AuthService,
        private userService: UserService,
        private snackBarService: SnackBarService,
        private gtmService: GTMService,
        private onboardingService: OnboardingService,
        private route: ActivatedRoute,
        private router: Router,
    ){}

    async ngOnInit() {    
        this.token = this.route.snapshot.params['token'];

        try {
            await this.onboardingService.checkUserToken(this.token);
        } catch (errors) {
            // redirect to the right transition page according to error type
            if (errors.error && errors.error.error) {
                switch (errors.error.error) {
                    case "already_in_team":
                        await this.router.navigate(['/onboarding/alreadyinteam']);
                        break;
                    case "token_expired":
                        await this.router.navigate(['/onboarding', this.token, 'expiredtoken']);
                        break;
                    case "token_invalid":
                        await this.router.navigate(['/onboarding/invalidtoken']);
                        break;
                    default:
                        this.log.error(errors.error.error);
                }
            }
        }
    }    

    async register () {
        const data = this.form.getRawValue();
        const { firstName, lastName, passwordSubForm, terms } = data;
        const password1 = passwordSubForm.password1;
        const password2 = passwordSubForm.password2;
       
        if (firstName && lastName && password1 && password2 && terms) {
            const form_encoded_data = "firstName=" + encodeURIComponent(firstName) +
                "&lastName=" + encodeURIComponent(lastName) +
                "&password.password1=" + encodeURIComponent(password1) +
                "&password.password2=" + encodeURIComponent(password2);

            try{
                const success = await this.onboardingService.registerUser(form_encoded_data, this.token);
                this.authService.setToken(success.token);
                this.userService.set(success.user);
                this.gtmService.push('$signup');
                await this.router.navigate(['/onboarding', success.user.teamMemberId, 'settings']);
            } catch (errors) {
                this.log.error(errors.error.error);
                this.snackBarService.error(errors.error.error);
            }
        }
    }
}